import {Strings} from 'Strings';
import {LocalStorageSvc} from './LocalStorageSvc';
import SpinnerSvc from 'services/SpinnerSvc';
import {Utils} from '../underscore-extensions';

export class TutorialSvc {
    $http: angular.IHttpService;
    $q: angular.IQService;
    $rootScope: ng.IRootScopeService;
    $state: ng.ui.IStateService;
    LocalStorageSvc: LocalStorageSvc;

    static videoTitleReg      = /(\(Tutorial\))| (in Animatron)| (Using Animatron)/gi;
    static youtubeApiKey      = 'AIzaSyDbtXVkjJEdvpaDGxWfFtSCNIAeHAqbcmQ';
    static currentVideo: youtube.Video;
    static tutorialModalShown = false;
    static $state: ng.ui.IStateService;
    static $q: ng.IQService;

    tutorialModalShown              = false;
    defered: ng.IDeferred<void>;
    promise: ng.IPromise<void>;
    videoList: Array<youtube.Video> = [];
    videos: Array<string>           = [];
    modalsOnPage: number;
    authors                         = [
        {
            id: 1,
            name: 'Bryce',
            avatar: 'https://yt3.ggpht.com/-mpIivOOuI0A/AAAAAAAAAAI/AAAAAAAAAAA/lA445HV9NK4/s100-c-k-no-mo-rj-c0xffffff/photo.jpg'
        },
        {
            id: 2,
            name: 'Alissa',
            avatar: 'https://yt3.ggpht.com/-mpIivOOuI0A/AAAAAAAAAAI/AAAAAAAAAAA/lA445HV9NK4/s100-c-k-no-mo-rj-c0xffffff/photo.jpg'
        },
        {
            id: 3,
            name: 'Priy',
            avatar: 'https://yt3.ggpht.com/-mpIivOOuI0A/AAAAAAAAAAI/AAAAAAAAAAA/lA445HV9NK4/s100-c-k-no-mo-rj-c0xffffff/photo.jpg'
        }
    ];

    private isFirstFetch = true;

    constructor() {
        TutorialSvc.$state = this.$state;
        TutorialSvc.$q     = this.$q;
        this.defered       = this.$q.defer<void>();
        this.promise       = this.defered.promise;
    }

    static getProduct() {
        return Utils.getProduct().toLowerCase();
    }

    public static onModalClose() {
        this.changeUrl(`${TutorialSvc.getProduct()}-tutorial`, {}).then(() => {
            TutorialSvc.tutorialModalShown = false;
            SpinnerSvc.hide();
        });
    }

    addToQueue(videoId: string) {
        this.videos.push(videoId);
        setTimeout(() => {
            if (this.videos.length === this.countModalsOnPage()) {
                this.fetchVideosData();
            }
        });
    }

    getVideo(id: string): ng.IPromise<youtube.Video> {
        return this.promise.then(() => this.findVideo(id));
    }

    fetchVideosData() {
        if (this.isFirstFetch) {
            this.removeStorageData();
        }
        this.isFirstFetch = false;

        const cachedData = this.videos.map(id => this.LocalStorageSvc.get<youtube.Video>(id));
        const ids        = this.videos.filter(id => !_.findWhere(cachedData, {id}));
        if (ids.length > 0) {
            this.$q.all(this.chunkify(ids).map(chunk => {
                const idsStr        = chunk.join(',');
                const params        = `part=snippet,contentDetails&id=${idsStr}&key=${TutorialSvc.youtubeApiKey}`;
                const youtubeApiUrl = `https://www.googleapis.com/youtube/v3/videos?${params}`;
                return this.$http.get<youtube.Youtube>(youtubeApiUrl);
            })).then(responses => {
                this.videoList = _.flatten(responses.map(r => r.data.items))
                    .map(i => this.processVideo(i)).concat(cachedData);
                this.defered.resolve();
            });
        } else {
            this.videoList = cachedData;
            this.defered.resolve();
        }
    }

    processVideo(videoItem: youtube.Item): youtube.Video {
        const videoData: youtube.Video = _.extend(
            {id: videoItem.id},
            videoItem.snippet,
            videoItem.contentDetails
        );
        videoData.title                = videoData.title.replace(TutorialSvc.videoTitleReg, '');
        videoData.description          = videoData.description.replace(/Helpful Links[\s\S]*/, '').trim();
        videoData.description          = videoData.description.replace(/Your Animatron Guru[\s\S]*/, '').trim();
        videoData.slug                 = this.slugify(videoData.title);
        this.LocalStorageSvc.set(videoData.id, videoData);
        return videoData;
    }

    calcTime(time: string) {
        const timeArr    = _.last(time.match(/((\d+)M)?(\d+)S/), 2); // parse date format: 'PT1M10S'
        const minute     = timeArr[0] || 0;
        const seconds    = timeArr[1] || '0';
        const secondsStr = parseInt(seconds, 10) / 10 < 1 ? `0${seconds}` : seconds.toString(); // if seconds = 3 then make 03
        return `${minute}:${secondsStr}`;
    }

    getCurrentVideo() {
        return TutorialSvc.currentVideo;
    }

    findVideo(id: string): youtube.Video {
        const video = _.findWhere(this.videoList, {id});

        if (video) {
            video.slug = video.slug || this.slugify(video.title);
        }

        return video;
    }

    setVideoDescription(id: string, text: string) {
        const video       = this.findVideo(id);
        video.description = text;
    }

    countModalsOnPage() {
        const modalElName = TutorialSvc.getProduct() === 'wave' ? 'wave-tutorials-item' : 'youtube-modal';
        return this.modalsOnPage || (this.modalsOnPage = document.querySelectorAll(modalElName).length);
    }

    openModal(id: string, authorId?: number) {
        this.getVideo(id).then(video => {
            TutorialSvc.currentVideo       = video;
            TutorialSvc.tutorialModalShown = true;

            if (authorId) {
                TutorialSvc.currentVideo.author = _.findWhere(this.authors, {id: authorId});
            }

            TutorialSvc.changeUrl(`${TutorialSvc.getProduct()}-tutorial`, {video: video.slug}).then(() => {
                this.$rootScope.setTitle('project.title', video.title);
                _.each(document.head.querySelectorAll('[name$="description"], [property="og:description"]'), el =>
                    (el as any).content = video.description
                );
            });
        });
    }

    private removeStorageData() {
        this.videos.forEach(id => this.LocalStorageSvc.remove<youtube.Video>(id));
    }

    private static changeUrl(state: string, params: any, replace = false): ng.IPromise<any> {
        if (!this.$state.includes(state)) return this.$q.resolve();
        const opts = {
            notify: false,
            location: (replace ? 'replace' : true)
        };
        return TutorialSvc.$state.transitionTo(state, params, opts);
    }

    private slugify(text: string) {
        return text.toString().toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
    }

    private chunkify(ids: string[], limit = 50) {
        return ids.reduce((ar, it, i) => {
            const ix = Math.floor(i / limit);
            if (!ar[ix]) ar[ix] = [];
            ar[ix].push(it);
            return ar;
        }, []);
    }
}

export type TutorialSvcFactory = new() => TutorialSvc;

function TutorialSvcFactory($http: angular.IHttpService,
                            $q: angular.IQService,
                            $rootScope: ng.IRootScopeService,
                            $state: ng.ui.IStateService,
                            LocalStorageSvc: LocalStorageSvc) {
    Object.assign(TutorialSvc.prototype, {
        $http, $q, $rootScope, $state, LocalStorageSvc
    });
    return TutorialSvc;
}

angular.module('animatronApp.tutorial').factory('TutorialSvcFactory', TutorialSvcFactory);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/TutorialSvc.ts